"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "midStorage", {
  enumerable: true,
  get: function () {
    return _midStorage.midStorage;
  }
});
var _sdk = require("@mid/sdk");
var _constants = _interopRequireWildcard(require("../../constants"));
var _location = require("../../utils/location");
var _SessionStorage = _interopRequireDefault(require("../../../shared/SessionStorage"));
var _auth = require("../../utils/auth");
var _midStorage = require("@mid/sdk/dist/lib/mid-storage");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class MID2AuthStrategy {
  constructor(redirectToIndex, customLogout, config) {
    this.execAuthentication = ({
      initAppframe
    }) => {
      const returnUrl = _SessionStorage.default.get(_constants.default.RETURN_URL);
      this.mid.isAuthed().then(authorized => {
        if (authorized) {
          if (returnUrl && returnUrl !== _constants.default.COMPLETED) {
            if (returnUrl !== window.location.href) {
              window.location.replace(returnUrl);
            }
          }
          _SessionStorage.default.set(_constants.default.RETURN_URL, _constants.default.COMPLETED);
          initAppframe({
            mid2Enabled: true,
            mid2AccessToken: this.accessToken
          });
          const pathname = (0, _location.removePrefix)(window.location.pathname, this.config.appPrefix);
          if (pathname.endsWith('logout')) this.redirectToIndex();
        } else {
          this.redirectToLogin();
        }
      });
    };
    this.redirectToLogin = () => {
      _SessionStorage.default.remove(_constants.default.MENU_KEY);
      if (!_SessionStorage.default.get(_constants.default.RETURN_URL)) {
        _SessionStorage.default.set(_constants.default.RETURN_URL, window.location.href);
      }
      this.mid.login().then(({
        accessToken
      }) => {
        global.console.debug('Successfully logged in');
        this.accessToken = accessToken;
      });
    };
    this.completed = authorized => {
      const pathname = (0, _location.removePrefix)(window.location.pathname, this.config.appPrefix);
      if (pathname === '/' || pathname === '') {
        this.redirectToIndex();
        return true;
      }
      const midReturnUrl = sessionStorage.getItem(_constants.default.MID_LAST_VISITED_URL);
      if (midReturnUrl && midReturnUrl !== window.location.href && midReturnUrl !== _constants.default.COMPLETED && pathname !== '/logout') {
        sessionStorage.setItem(_constants.default.MID_LAST_VISITED_URL, _constants.default.COMPLETED);
        window.location.href = midReturnUrl;
      }
      return authorized;
    };
    this.logout = () => {
      this.accessToken = null;
      if (!window.location.pathname.endsWith('logout')) _SessionStorage.default.set(_constants.default.RETURN_URL, window.location.href);
      this.mid.logout();
    };
    this.name = _constants.AUTH_STRATEGY.MID2;
    this.config = config;
    this.redirectToIndex = redirectToIndex;
    this.customLogout = customLogout;
    this.accessToken = null;
    this.mid = new _sdk.Mid({
      loginInfo: {
        appId: this.config.auth.clientID,
        oidcConfigUrl: this.config.auth.loginServer,
        authDriver: 'mid'
      },
      redirectUrl: `${window.location.origin}${this.config.appPrefix}`,
      logoutRedirectUrl: `${window.location.origin}${this.config.appPrefix}/logout`,
      flow: 'auth_code',
      setCookie: async data => {
        if (!data) {
          this.accessToken = null;
        } else {
          this.accessToken = data.accessToken;
          (0, _auth.setAuthCookie)(data.accessToken);
        }
      },
      landingFn: async ({
        accessToken
      }) => {
        window.location.hash = '';
        this.accessToken = accessToken;
      },
      baseUri: config.appPrefix,
      multiTab: true
    });
  }
}
var _default = exports.default = MID2AuthStrategy;